import { createClient } from 'next-sanity'

import { apiVersion, dataset, projectId } from '../env'

export const client = createClient({
  projectId,
  dataset,
  maxRetries: 2,
  retryDelay: () => 200,
  apiVersion,
  useCdn: false, // Disabled for ISR and on-demand revalidation
  token: process.env.SANITY_API_TOKEN, // Add write token for server-side operations
  perspective: 'published', // Only fetch published documents
  stega: {
    enabled: false,
    studioUrl: '/studio',
  },
})
